export default __webpack_public_path__ + "static/media/xvg.cb3eb231.svg";